var React = require('react');

function TemplateBadge (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 4.43886C0 6.89038 2.00658 8.87773 4.48182 8.87773C6.95705 8.87773 8.96363 6.89038 8.96363 4.43886C8.96363 1.98735 6.95705 0 4.48182 0C2.00658 0 0 1.98735 0 4.43886ZM5.2192 3.63715H6.03824C6.42129 3.63715 6.73182 3.32662 6.73182 2.94357C6.73182 2.56052 6.42129 2.25 6.03824 2.25H2.94357C2.56052 2.25 2.25 2.56052 2.25 2.94357C2.25 3.32662 2.56052 3.63715 2.94357 3.63715H3.81863V5.98858C3.81863 6.37534 4.13216 6.68886 4.51892 6.68886C4.90568 6.68886 5.2192 6.37534 5.2192 5.98858V3.63715Z","fill":"#424242"}));
}

TemplateBadge.defaultProps = {"width":"11","height":"11","viewBox":"0 0 9 9","fill":"none"};

module.exports = TemplateBadge;

TemplateBadge.default = TemplateBadge;
